/* Assemble Instructions - video oynatma (FNY 04.09.2026)
   Poster uzerindeki play butonuna basilinca kontroller aciliyor ve video
   oynuyor. Boylece kart durgun halde temiz bir kapak gorseli gosteriyor,
   tarayici kontrol cubugu goruntuyu kirletmiyor. */
(function () {
  'use strict';
  function bagla(root) {
    var cards = root.querySelectorAll('.asm-card');
    for (var i = 0; i < cards.length; i++) {
      (function (card) {
        if (card.__asmBound) { return; }
        card.__asmBound = true;
        var v = card.querySelector('[data-asm-video]');
        var b = card.querySelector('[data-asm-play]');
        if (!v || !b) { return; }
        var oynat = function () {
          card.classList.add('is-playing');
          v.setAttribute('controls', '');
          var p = v.play();
          if (p && p.catch) { p.catch(function () {}); }
        };
        b.addEventListener('click', oynat);
        v.addEventListener('play', function () { card.classList.add('is-playing'); v.setAttribute('controls',''); });
        v.addEventListener('pause', function () { if (v.currentTime === 0) { card.classList.remove('is-playing'); } });
        v.addEventListener('ended', function () {
          card.classList.remove('is-playing');
          v.removeAttribute('controls');
          try { v.currentTime = 0; v.load(); } catch (e) {}
        });
        // sure etiketi bos ise metadata'dan doldur
        var dur = card.querySelector('.asm-dur');
        if (dur && !dur.textContent.trim()) {
          v.addEventListener('loadedmetadata', function () {
            if (!isFinite(v.duration)) { return; }
            var m = Math.floor(v.duration / 60), s = Math.round(v.duration % 60);
            dur.textContent = m + ':' + (s < 10 ? '0' : '') + s;
          });
        }
      })(cards[i]);
    }
  }
  function init() {
    var w = document.querySelectorAll('.asm-wrap');
    for (var i = 0; i < w.length; i++) { bagla(w[i]); }
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); }
  else { init(); }
  document.addEventListener('shopify:section:load', init);
})();
